import Signal from './Signal';

export default Signal;
